import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import { Zoom } from "react-reveal";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import { ThemeContext } from "../../context/ThemeContext";
import { useBusinessNameContext } from "../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { trackCategoryViewed } from "../../utils/mixpanel";
import { ShowSpas } from "../../API/SPAAPI";
import { isClosedNow } from "../../utils/availability";
import ClosableLink from "../../new-components/closed-badge/ClosableLink";
import ClosableCard from "../../new-components/closed-badge/ClosableCard";

function Spas() {
  const { room_uuid, uuid } = useParams();
  const { businessName, setBusinessName } = useBusinessNameContext();
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const lang = sessionStorage.getItem("lang");

  let spas;
  let bgColor;
  let color;
  let text;
  let spaItems;
  const { data, isLoading, error } = ShowSpas(room_uuid, lang);

  if (!isLoading) {
    if (error) {
      if (error?.response.status == 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data.data.success === false) {
        navigate(`/${room_uuid}/qr-scan`);
      } else {
        spas = data.data.data;
        spaItems = spas.spas;
        color = spas.color;
        bgColor = spas.header_color;
        text = spas.title;
        if (spaItems?.length === 1 && !isClosedNow(spaItems[0])) {
          navigate(`/${room_uuid}/spa/${spaItems[0].uuid}`, { replace: true });
        }
      }
    }
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return (
    <div className={theme ? "food pb-1" : ""}>
      {theme ? <Title title={text} /> : <HeaderInner headerName={text} />}
      <main className="home-main bg-white pt-3">
        <div className={theme ? "box_food" : ""}>
          {isLoading ||
          (spaItems.length === 1 && !isClosedNow(spaItems[0])) ? (
            <CustomBusinessServiceLoader
              businessName={businessName}
              loader={"spa"}
            />
          ) : spaItems.length > 0 ? (
            spaItems.map((x, idx) => {
              return theme ? (
                <div key={idx}>
                  <ClosableLink
                    closed={isClosedNow(x)}
                    to={`/${room_uuid}/spa/${x.uuid}`}
                    onClick={() => {
                      trackCategoryViewed({
                        category_id: x.uuid,
                        category_name: x.name,
                        category_type: "spa",
                        is_external: x.is_external == 1 ? true : false,
                      });
                    }}
                  >
                    <img src={x?.image} alt="" className="booking_img" />
                    <img src={Overllay} alt="" className="overlay" />
                    <div className="text_food">
                      <h5 className="">{x.name}</h5>
                    </div>{" "}
                  </ClosableLink>
                </div>
              ) : (
                <div id={x.name} key={idx}>
                  <Zoom>
                    <ClosableCard
                      closed={isClosedNow(x)}
                      className="con-img-container v3"
                      onClick={() => navigate(`/${room_uuid}/spa/${x.uuid}`)}
                    >
                      <div className="con-img">
                        <img src={x.banners[0]?.image} alt="" />
                        <p></p>
                      </div>
                    </ClosableCard>
                    <div className="con-text-container">
                      <p>{x.name}</p>
                      <hr className="mb-0 dark" />
                    </div>
                  </Zoom>
                </div>
              );
            })
          ) : null}
        </div>
      </main>
      {theme && <NewFooter />}
    </div>
  );
}
export default Spas;
